/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Audit_HistoryInputs */



/**
* | output |
* | --- |
* | "Full activity history for all users" |
*
* @param {Plan_Gate_Benefit_Audit_HistoryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_audit_history = /** @type {((inputs?: Plan_Gate_Benefit_Audit_HistoryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Audit_HistoryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständiger Aktivitätsverlauf für alle Benutzer")
	return /** @type {LocalizedString} */ ("Full activity history for all users")
});